import brand from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import { VariantTheme } from '@helpers/themeEnums';
import styled from 'styled-components';
const Container = styled.section `
  --sectionBackground: transparent;
  --sectionColour: ${brand.global.black};
  --sectionSpacingBottom: var(--sectionSpacing);
  --sectionSpacingTop: var(--sectionSpacing);

  scroll-margin: var(--headerHeight) 0 0;
  background-color: var(--sectionBackground);
  color: var(--sectionColor);

  &[data-flush='top'] {
    --sectionSpacingTop: 0;
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;
  }

  &[data-variant-theme=${VariantTheme.White}] {
    --sectionBackground: ${brand.global.white};
  }

  &[data-variant-theme=${VariantTheme.Black}] {
    --sectionBackground: ${brand.global.black};
    --sectionColor: ${brand.global.white};
  }

  &[data-variant-theme=${VariantTheme.Teal}] {
    --sectionBackground: ${brand.tealAccessibleDark.base};
    --sectionColor: ${brand.global.white};
  }
`;
const Inner = styled.div `
  ${siteWide};

  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);
`;
const SectionWrapperStyles = {
    Container,
    Inner,
};
export default SectionWrapperStyles;
